/**
 * @generated SignedSource<<fb0c83afcd03081aa071628eaeabadbf>>
 * @relayHash eadd29b81e154002b041bff45fe70c11
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4ee3c4b6e8b69df15d5f688edf66cbba4b2adf8d328e72408e263ec648a802f1

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type StatuspageDetailsPageQuery$variables = {
  pageId: string;
};
export type StatuspageDetailsPageQuery$data = {
  readonly stakeholderComms_getPageById: {
    readonly error: string | null | undefined;
    readonly page: {
      readonly name: string;
      readonly " $fragmentSpreads": FragmentRefs<"StatuspageDetails">;
    } | null | undefined;
  } | null | undefined;
};
export type StatuspageDetailsPageQuery = {
  response: StatuspageDetailsPageQuery$data;
  variables: StatuspageDetailsPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pageId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "pageId",
    "variableName": "pageId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "error"
},
v3 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "StatuspageDetailsPageQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "StakeholderCommsPageResponse",
        "kind": "LinkedField",
        "name": "stakeholderComms_getPageById",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "StakeholderCommsPage",
            "kind": "LinkedField",
            "name": "page",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "FragmentSpread",
                "name": "StatuspageDetails"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StatuspageDetailsPageQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "StakeholderCommsPageResponse",
        "kind": "LinkedField",
        "name": "stakeholderComms_getPageById",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "StakeholderCommsPage",
            "kind": "LinkedField",
            "name": "page",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "kind": "ScalarField",
                "name": "domain"
              },
              {
                "kind": "ScalarField",
                "name": "description"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "4ee3c4b6e8b69df15d5f688edf66cbba4b2adf8d328e72408e263ec648a802f1",
    "metadata": {},
    "name": "StatuspageDetailsPageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "02ffc2af429e1859237b3c8a7de32a99";

export default node;
